import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import logo from "assets/images/logo.png";

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    this.sidebar = React.createRef();
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }

  render() {
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className="logo">
          <a
            href="https://dev.dhbtools.com/"
            className="simple-text logo-mini"
          >
            <div className="logo-img">
              <img src={logo} alt="react-logo" />
            </div>
          </a>
          <a
            href="https://dev.dhbtools.com/"
            className=" simple-text logo-normal"
          >
            DHB Tools
          </a>
        </div>
        <div className="sidebar-wrapper" ref={this.sidebar}>
          <Nav>
            {this.props.routes.filter(r => !r.hidden).map((prop, key) => {
              // Nếu là "divider" => hiển thị <hr>
              // Trong Sidebar.js, ngay chỗ if (prop.divider) {
              if (prop.divider) {
                return (
                  <hr
                    key={key}
                    style={{
                      // Chỉ dày 1px
                      border: '0',
                      height: '1px',
                      // Màu mờ mờ
                      backgroundColor: '#909090',
                      // Chiều rộng (ví dụ 50% thôi)
                      width: '80%',
                      // Canh giữa
                      margin: '10px auto',
                    }}
                  />
                );
              }


              // Còn lại => hiển thị route bình thường
              return (
                <li
                  className={
                    this.activeRoute(prop.path) + (prop.pro ? "" : "")
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            })}
          </Nav>
        </div>
      </div>
    );
  }
}

export default Sidebar;
